import { createSimpleGlobalState } from "../hooks/simpleGlobalState"
import { xRMApiIncident } from "../types/xRM"

type IncidentState = {
  loading: boolean
  incidents: xRMApiIncident[]
}

const { getValue, setValue, resetValue, mergeValue, useValue } =
  createSimpleGlobalState<IncidentState>(
    {
      loading: true,
      incidents: [],
    },
    "incidents",
  )

export {
  getValue as getIncidents,
  mergeValue as mergeIncidents,
  resetValue as resetIncidents,
  setValue as setIncidents,
  useValue as useIncidents,
}
